import React, { useState } from "react";
import { Button, Card, Col, Form, Row, InputGroup } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Swal from "sweetalert2";
import { userServices } from "../../../APIServices/UserData/userServices";
import { authServices } from "../../../APIServices/UserData/authServices";

const ChangePassword = () => {
  const [loader, setLoader] = useState("");

  const [show, setShow] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });

  const toggleEye = (field) => {
    setShow((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setPasswords({ current: "", new: "", confirm: "" });
    setShow({ current: false, new: false, confirm: false });
  };

  const changePassword = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Change Password?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.currentPassword = passwords.current;
        userData.newPassword = passwords.new;
        userData.repeatPassword = passwords.confirm;
        let data = await userServices.changePassword(userData);
        if (data?.statusCode === 200) {
          setPasswords({ current: "", new: "", confirm: "" });
          await authServices.logout();
        }
        setLoader(false);
      }
    });
  };

  return (
    <div className="h-100 d-flex flex-column">
      {/* Header */}
      <div className="bg-white border-bottom px-4 py-3">
        <div className="hstack justify-content-between">
          <h6 className="fw-semibold m-0">Change Password</h6>
        </div>
      </div>

      {/* Content */}
      <div className="flex-grow-1 overflow-auto p-4">
        <Row className="g-4 justify-content-center">
          <Col xxl={4} lg={6} md={8}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                {/* Current Password */}
                <Form.Group className="mb-3">
                  <Form.Label>Current Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={show.current ? "text" : "password"}
                      name="current"
                      value={passwords.current}
                      onChange={handleChange}
                      placeholder="Enter current password"
                    />
                    <InputGroup.Text
                      className="cursor-pointer"
                      onClick={() => toggleEye("current")}
                    >
                      {show.current ? <FiEyeOff /> : <FiEye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>

                {/* New Password */}
                <Form.Group className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={show.new ? "text" : "password"}
                      name="new"
                      value={passwords.new}
                      onChange={handleChange}
                      placeholder="Enter new password"
                    />
                    <InputGroup.Text
                      className="cursor-pointer"
                      onClick={() => toggleEye("new")}
                    >
                      {show.new ? <FiEyeOff /> : <FiEye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>

                {/* Confirm Password */}
                <Form.Group className="mb-3">
                  <Form.Label>Confirm New Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={show.confirm ? "text" : "password"}
                      name="confirm"
                      value={passwords.confirm}
                      onChange={handleChange}
                      placeholder="Confirm new password"
                    />
                    <InputGroup.Text
                      className="cursor-pointer"
                      onClick={() => toggleEye("confirm")}
                    >
                      {show.confirm ? <FiEyeOff /> : <FiEye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <div className="d-flex gap-2 justify-content-end">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" disabled={loader || !passwords.current || !passwords.new || !passwords.confirm} size="sm" onClick={changePassword}>
                    Save
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ChangePassword;
